// Pure helpers for the Scan jobs page: plain names and states, counters, filters and where a scan's results live.
import { scanLabel } from './webScanLogic';
import { kindLabel } from './networkScanLogic';

const OTHER = {
  dns_recon: 'DNS recon', dns_health: 'DNS health', subdomain_recon: 'Subdomain recon', favicon_pivot_recon: 'Favicon pivot', port_scan: 'Port enumeration',
  cloud_aws_audit: 'AWS audit', cloud_multi_audit: 'Cloud audit', mobile_static: 'Mobile static analysis', mobile_dynamic: 'Mobile dynamic analysis',
  mobile_package_vuln: 'Mobile package check', local_addon: 'Local add-on sync', threat_check: 'Threat alert check'
};
export const whatLabel = (type) => OTHER[type] || (String(type).startsWith('network_') ? kindLabel(type) : scanLabel(type));

export const STATE = {
  running: { label: 'RUNNING', color: '#22c55e' }, pending: { label: 'WAITING', color: '#f59e0b' }, paused: { label: 'PAUSED', color: '#38bdf8' },
  completed: { label: 'DONE', color: '#94a3b8' }, failed: { label: 'FAILED', color: '#ef4444' }, cancelled: { label: 'STOPPED', color: '#64748b' }
};
export const stateOf = (s) => STATE[s.status] || STATE.pending;
export const isLive = (s) => ['running', 'pending', 'paused'].includes(s.status);

// Page the results of a finished scan are shown on.
export function resultsPath(type) {
  const t = String(type);
  if (t.startsWith('network_')) return '/network-scans';
  if (t.startsWith('cloud_')) return '/cloud-scans';
  if (t.startsWith('mobile_')) return '/mobile-scans';
  if (t.startsWith('api_') || t === 'graphql_security') return '/api-security';
  if (['dns_recon', 'dns_health', 'subdomain_recon', 'favicon_pivot_recon'].includes(t)) return '/recon';
  if (t === 'port_scan') return '/enum';
  if (t === 'secrets_git_history') return '/secrets';
  return '/web-scans';
}

export const failureText = (s) => {
  if (s.status === 'cancelled') return 'You stopped this scan before it finished.';
  const m = String(s.error_message || '').trim();
  return m ? `${m}${/[.!?]$/.test(m) ? '' : '.'}` : 'No reason was recorded for this failure.';
};

// A rerun is a new scan with the same address and settings.
export const retryBody = (s) => ({ user_target: s.user_target, scan_type: s.scan_type, options: s.options || {} });

export function counters(scans, now = new Date()) {
  const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  const today = (s) => new Date(s.finished_at || s.created_at).getTime() >= midnight;
  return {
    running: scans.filter((s) => s.status === 'running').length,
    waiting: scans.filter((s) => s.status === 'pending' || s.status === 'paused').length,
    done: scans.filter((s) => s.status === 'completed' && today(s)).length,
    failed: scans.filter((s) => s.status === 'failed' && today(s)).length
  };
}

export const FILTERS = [
  { id: 'all', label: 'All', test: () => true }, { id: 'running', label: 'Running', test: (s) => s.status === 'running' },
  { id: 'waiting', label: 'Waiting', test: (s) => s.status === 'pending' || s.status === 'paused' },
  { id: 'failed', label: 'Failed', test: (s) => s.status === 'failed' }, { id: 'done', label: 'Done', test: (s) => s.status === 'completed' }
];

export function filterJobs(scans, filter, q) {
  const f = FILTERS.find((x) => x.id === filter) || FILTERS[0];
  const s = q.trim().toLowerCase();
  return scans.filter((j) => f.test(j) && (!s || `${j.id} ${whatLabel(j.scan_type)} ${j.target_value} ${j.target_name}`.toLowerCase().includes(s)));
}
